const defaults = {
  avatar: null,
  companyAvatar: null,
  displayAvatarOption: null,
  headline: null,
  publicDisplayAvatarOption: null
};
export function createDisplayInfo(json) {
  var _json$avatar, _json$companyAvatar, _json$displayAvatarOp, _json$headline, _json$publicDisplayAv;
  if (!json) return Object.assign({}, defaults);
  return {
    avatar: (_json$avatar = json.avatar) !== null && _json$avatar !== void 0 ? _json$avatar : null,
    companyAvatar: (_json$companyAvatar = json.companyAvatar) !== null && _json$companyAvatar !== void 0 ? _json$companyAvatar : null,
    displayAvatarOption: (_json$displayAvatarOp = json.displayAvatarOption) !== null && _json$displayAvatarOp !== void 0 ? _json$displayAvatarOp : null,
    headline: (_json$headline = json.headline) !== null && _json$headline !== void 0 ? _json$headline : null,
    publicDisplayAvatarOption: (_json$publicDisplayAv = json.publicDisplayAvatarOption) !== null && _json$publicDisplayAv !== void 0 ? _json$publicDisplayAv : null
  };
}